var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNetlify(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    stroke: "#ffffff",
    strokeWidth: 0,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.14645 0.146447C7.34172 -0.0488155 7.6583 -0.0488155 7.85356 0.146447L8.83363 1.12651L7.01342 4.06685L4.30815 2.98475L7.14645 0.146447Z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.53884 3.75406L2.42638 4.86652L4.71994 7.7717L6.47901 4.93012L3.53884 3.75406Z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.7144 5.5785L0.146455 7.14645C0.12315 7.16975 0.102626 7.19478 0.0848846 7.22113L3.60707 7.97589L1.7144 5.5785Z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.659968 8.36707L1.66655 9.37365L2.84238 8.83473L0.659968 8.36707Z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.42086 10.128L2.93996 10.6471L3.59422 9.59016L2.42086 10.128Z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.66637 11.3735L7.14645 14.8536C7.34172 15.0488 7.6583 15.0488 7.85356 14.8536L8.17746 14.5297L8.2957 13.9148L4.81919 9.51124L3.66637 11.3735Z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.43824 13.2689L11.9259 10.7812L9.99616 10.3677L9.43824 13.2689Z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7681 9.93897L14.549 8.15812L10.7159 6.62489L10.185 9.38545L12.7681 9.93897Z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9209 7.22983C14.9018 7.20028 14.8794 7.1723 14.8536 7.14645L12.9906 5.28349L11.6226 5.91051L14.9209 7.22983Z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2363 4.52918L11.2992 3.59205L11.0109 5.0908L12.2363 4.52918Z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4451 2.73797L9.56004 1.85293L7.9561 4.44392L9.96267 5.24655L10.4451 2.73797Z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.9983 8.48829L9.6622 6.80901L9.20703 9.17588L5.9983 8.48829Z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.11237 9.53544L9.01814 10.1581L8.54526 12.6171L6.11237 9.53544Z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.18693 7.30181L9.08617 5.97299L7.42169 5.3072L6.18693 7.30181Z",
    fill: "#ffffff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetlify);
export default __webpack_public_path__ + "static/media/netlify.3091b322a456d2be2d8175679abe09b1.svg";
export { ForwardRef as ReactComponent };